export default __webpack_public_path__ + "static/media/WEG.fc9b48e1.jpg";